import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, LocalService, PageKey } from 'src/service/local.service';

@Component({
  selector: 'app-link-businesses',
  templateUrl: './link-businesses.component.html',
  styleUrl: './link-businesses.component.scss'
})
export class LinkBusinessesComponent {
  lstSectionConfigKeys: string[] = ["seller", "table"]; maxBodyHeight = 0;
  businessId: string = ''; ctryCode: string = ''; interactionType = 0;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.businessId = routeParams.businessId;

      this.configurationManagementService.ensurePageActions(PageKey.LinkBusinesses);

      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId, false, this.interactionType == InteractionType.User ? routeParams.businessId : '');
        this.ctryCode = routeParams.ctryCode;
        this.businessId = routeParams.businessId ? routeParams.businessId : '';
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {

  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
      } break;
      case 2: {
      } break;
    }
  }
}
